<app-service-settings-common
    [hideShareWithOtherServicesInput]="true"
    [settingsKey]="SERVICE_SETTINGS_MOVEMENT_RESTRICTION_TYPE_KEY"
    [title]="'workData.movementRestriction.labelMulti'"
></app-service-settings-common>
